import React from "react";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.63598 10.8071C8.51275 11.7045 7.08856 12.1377 5.6559 12.0178C4.22324 11.8979 2.89086 11.234 1.93241 10.1624C0.973951 9.09086 0.462174 7.69297 0.502181 6.25586C0.542187 4.81875 1.13094 3.4515 2.14753 2.43491C3.16411 1.41833 4.53136 0.829575 5.96847 0.789568C7.40559 0.749562 8.80347 1.26134 9.87504 2.21979C10.9466 3.17825 11.6105 4.51063 11.7304 5.94329C11.8503 7.37595 11.4171 8.80014 10.5197 9.92337L15.3172 14.7196C15.4346 14.837 15.5005 14.9962 15.5005 15.1621C15.5005 15.3281 15.4346 15.4873 15.3172 15.6046C15.1999 15.722 15.0407 15.7879 14.8747 15.7879C14.7088 15.7879 14.5496 15.722 14.4322 15.6046L9.63598 10.8071ZM10.4997 6.41212C10.4997 5.83759 10.3866 5.26868 10.1667 4.73788C9.94684 4.20708 9.62458 3.72478 9.21832 3.31853C8.81207 2.91227 8.32977 2.59001 7.79897 2.37015C7.26817 2.15028 6.69927 2.03712 6.12473 2.03712C5.5502 2.03712 4.98129 2.15028 4.45049 2.37015C3.91969 2.59001 3.4374 2.91227 3.03114 3.31853C2.62488 3.72478 2.30262 4.20708 2.08276 4.73788C1.86289 5.26868 1.74973 5.83759 1.74973 6.41212C1.74973 7.57244 2.21067 8.68524 3.03114 9.50571C3.85161 10.3262 4.96441 10.7871 6.12473 10.7871C7.28506 10.7871 8.39785 10.3262 9.21832 9.50571C10.0388 8.68524 10.4997 7.57244 10.4997 6.41212Z"
      fill="#2E3333"
    />
  </svg>
);

export default SearchIcon;

